import { IS_FLIPGIVE } from 'common/env';

export type FlipgiveMigrationBannerDestination = 'order-history' | 'wallet';

export interface FlipgiveMigrationBannerInput {
    hasFetchedFFs: boolean;
    isBannerDisabled: boolean | undefined;
    rawMigrationDate: string;
    destination?: FlipgiveMigrationBannerDestination;
}

export interface FlipgiveMigrationBannerState {
    show: boolean;
    text: string;
}

const DESTINATION_COPY: Record<
    FlipgiveMigrationBannerDestination,
    { withDate: (date: string) => string; noDate: string }
> = {
    'order-history': {
        withDate: (date) => `To view orders prior to ${date}, go to Shop Online Order History.`,
        noDate: 'To view past orders, go to Shop Online Order History.',
    },
    wallet: {
        withDate: (date) =>
            `To view gift cards purchased prior to ${date}, go to the Legacy Gift Cards.`,
        noDate: 'To view past gift card orders, go to the Legacy Gift Cards.',
    },
};

const sanitizeMigrationDate = (raw: string): string => {
    const trimmed = (raw || '').trim();
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
        return '';
    }
    return trimmed;
};

export const getFlipgiveMigrationBannerState = ({
    hasFetchedFFs,
    isBannerDisabled,
    rawMigrationDate,
    destination = 'order-history',
}: FlipgiveMigrationBannerInput): FlipgiveMigrationBannerState => {
    const show = IS_FLIPGIVE && hasFetchedFFs && !isBannerDisabled;
    if (!show) {
        return { show: false, text: '' };
    }

    const date = sanitizeMigrationDate(rawMigrationDate);
    const copy = DESTINATION_COPY[destination];
    return {
        show: true,
        text: date ? copy.withDate(date) : copy.noDate,
    };
};
